import createReactComponent from '../createReactComponent';
export default createReactComponent('sort', 'Sort', [["path",{"d":"M4.5 7h15m-15 5h10m-10 5h4","key":"svg-0"}]]);